"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 04 05 2019
 */

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");
/**
 * Flag indicating that {@link SelloutSupply} has been changed with respect to any business rule(s).
 * <br/>
 * We have to save information about the type of sellout, as there can be more types on the same combination of product/site.
 *
 * @author JMe
 */


var SelloutSupplyChanged =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(SelloutSupplyChanged, _EntityEventFlag_1$En);

  /**
   * Ctor.
   *
   * @param selloutType type of sellout
   */
  function SelloutSupplyChanged(selloutType) {
    var _this;

    _classCallCheck(this, SelloutSupplyChanged);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSupplyChanged).call(this));
    _this.title = selloutType;
    return _this;
  }

  _createClass(SelloutSupplyChanged, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return SelloutSupplyChanged;
}(EntityEventFlag_1.EntityEventFlag);

exports.SelloutSupplyChanged = SelloutSupplyChanged;
SelloutSupplyChanged.TAG = EntityEventFlag_1.EntityEventFlag.register(SelloutSupplyChanged);